import React, { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Select from '../../common/Form/Select';
import { actualValueForDropdown, debounce } from '../../utils/common';
import Input from '../../common/Form/Input';
import { useFormContext } from 'react-hook-form';
import { getAssetsTypeList } from '../../actions/inventory';
import { CLEAR_ASSETS_TYPE_DROPDOWN_LIST_DATA } from '../../types/inventory';

export default function AssetType({ name, label, onChange = () => { }, org_id, addNew = false, required = false, prefill = [], readOnly = false, labelClassName = '', clearOnUnmount = true, reuseLoadedOptions = false }) {
    const dispatch = useDispatch();
    const assetsTypeDropdown = useSelector((state) => state.inventory.assetsTypeDropdown);
    const isAssetsTypeDropdownLoading = useSelector((state) => state.loading.isAssetsTypeDropdownLoading);
    const { watch, setValue } = useFormContext();

    const memoizedAssetsTypeDropdown = useMemo(() => {
        const siteOptions = assetsTypeDropdown || [];
        return addNew ? [{ label: 'Add New Asset Type', value: 'add-new-asset-type' }, ...siteOptions] : siteOptions;
    }, [assetsTypeDropdown, addNew]);


    const getList = ({ limit = 100, page = 1, query = '', org_id }) => {
        dispatch(getAssetsTypeList({ limit, page, query, dropdown: true, payload: { org_id } }));
    };

    const debouncedAssetsTypeSearchSearch = useCallback(debounce(getList), []);

    useEffect(() => {
        const hasReusableOptions = reuseLoadedOptions && memoizedAssetsTypeDropdown.length > 0;
        if (org_id && !hasReusableOptions && !isAssetsTypeDropdownLoading) {
            getList({ limit: 100, page: 1, query: '', org_id });
        }
    }, [org_id]);

    useEffect(() => {
        return () => {
            if (clearOnUnmount) dispatch({ type: CLEAR_ASSETS_TYPE_DROPDOWN_LIST_DATA });
        }
    }, [dispatch, clearOnUnmount]);

    useEffect(() => {
        if (prefill.length > 0 && memoizedAssetsTypeDropdown.length > 0) {
            const prefilledValue = memoizedAssetsTypeDropdown.find(option => prefill.includes(option.value));
            if (prefilledValue) {
                setValue(name, prefilledValue);
            }
        }
    }, [prefill, memoizedAssetsTypeDropdown, setValue, name]);

    const isAddNew = actualValueForDropdown(watch(name)) === 'add-new-asset-type';

    return (
        <>
            <Select
                className='w-full'
                label={label}
                name={name}
                options={memoizedAssetsTypeDropdown}
                isLoading={isAssetsTypeDropdownLoading}
                onInputChange={(event) => {
                    if (event.length > 0) {
                        debouncedAssetsTypeSearchSearch({ query: event, org_id })
                    }
                }}
                onChange={(event) => {
                    const value = event?.value;
                    onChange(value)
                }}
                required={required}
                readOnly={readOnly}
                labelClassName={labelClassName}
            />
            {/* {isAddNew && <Input
                className='w-full'
                label={`${label} (New)`}
                name={`${name}:new`}
                required
            />} */}
        </>
    )
}



const RenderAddNewAssetType = ({ name, label }) => {
    return (
        <Input
            className='w-full'
            label={`${label} (New)`}
            name={`${name}:new`}
            required={true}
            shouldUnregister={true}
        />
    )
}
